module.exports = __webpack_public_path__ + "img/data_moun_qj.aed0bbdc.png";